/**
 * Resend-code countdown timer used by every OTP card.
 *
 * Mockup shows "(00:42)" / "(00:30)" / "(00:24)" — a 60s lockout from
 * the moment the previous send happened. While running, the button
 * label dims and is disabled; on 0 it re-enables and the countdown
 * span hides.
 */

"use client";

import { useEffect, useState } from "react";

const COOLDOWN_MS = 60_000;

export function useResendCountdown(lastResendAt: number | null) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (lastResendAt == null) return;
    const id = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(id);
  }, [lastResendAt]);

  const elapsed = lastResendAt == null ? COOLDOWN_MS : now - lastResendAt;
  const remainingMs = Math.max(0, COOLDOWN_MS - elapsed);
  const remainingSec = Math.ceil(remainingMs / 1000);
  const disabled = remainingMs > 0;

  const mm = Math.floor(remainingSec / 60)
    .toString()
    .padStart(2, "0");
  const ss = (remainingSec % 60).toString().padStart(2, "0");

  return {
    disabled,
    remainingSec,
    label: `(${mm}:${ss})`,
  };
}
